export { default } from "./StaticPollOption";
